import { render } from "./chamamento-fechado.vue?vue&type=template&id=351d4ac5&scoped=true"
import script from "./chamamento-fechado.vue?vue&type=script&lang=js"
export * from "./chamamento-fechado.vue?vue&type=script&lang=js"

import "./chamamento-fechado.vue?vue&type=style&index=0&id=351d4ac5&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351d4ac5"]])

export default __exports__